import React from 'react'
import Select from './Select'

const FormSelect = ({
  errorMessage = '',
  className = '',
  showSelectAll = false,
  ...props
}) => {
  const hasError = Boolean(errorMessage)
  return (
    <div className={className}>
      <Select
        error={hasError}
        showSelectAll={showSelectAll}
        {...props}
      />
      {hasError ? (
        <div className="text-danger small mt-1">
          {errorMessage}
        </div>
      ) : null}
    </div>
  )
}

export default FormSelect